
















































































import { Vue, Component } from 'vue-property-decorator';
import Gtcharts from '@/components/charts.vue';
import { DateFormat } from '@/utils/dateformat';
import {
    tooltip_formatter, getBarXdata, dataChartFromat, formatSum,
} from '@/utils/formate';
import {
    lineNegativeOption, lineMore4Option, barNegativeOption, pieLabelLineOption,
} from '@/chart.config/options';
import baseUrl from '@/api/common';
import { getCurrentChargeAppReport, getCurrentApplist, getCurrentoperatorAppReport } from '@/api/share';

@Component({
    components: {
        Gtcharts,
    },
})
export default class OPreport extends Vue {
    private defaultActive:number = 0;

    private captchaList: Array<any> = [{ app_name: '全部', _id: '', key: '' }];

    private start_time:any = new Date();

    private end_time: any = new Date();

    private timeChoose: number = 0;

    private lineOption:any = {};

    private totalFee:any = {}

    private requestOption:any = {}

    private requestData :any = {}

    private gateWay:any = {}

    private barOption:any = {};

    private pieOption:any = {};

    private failData :any = {}

    private currentID:any = 'all';

    private privateThis:any = this;

    private isDownload:boolean = false

    private type:string = '';

    private backendMsg: any = '';

    // App 名称选择触发
    getAppID(e:any) {
        this.currentID = e.app_name !== '全部' ? e._id : 'all';
        this.getData();
    }

    changeTime(time:any, left:any) {
        if (left) {
            if (this.start_time === time) {
                return;
            }
            this.start_time = time;
        } else {
            if (this.end_time === time) {
                return;
            }
            this.end_time = time;
        }
        this.timeChoose = 0;
        this.getData();
    }

    //
    chooseTime(num:number) {
        this.timeChoose = num;
        if (num === 1) {
            this.end_time = DateFormat(new Date()).subtract(1, 'DD');
        } else {
            this.end_time = DateFormat(new Date());
        }
        this.start_time = DateFormat(new Date()).subtract(num, 'DD');
        this.getData();
    }

    // 导出
    exportReport(type: string) {
        this.type = type;
        this.isDownload = true;
    }

    //
    getData() {
        const data = {
            _id: this.currentID,
            start: DateFormat(this.start_time).format('YYYY-MM-DD'),
            end: DateFormat(this.end_time).format('YYYY-MM-DD'),
            product: 'APP本机校验',
        };
        this.getResultChart(data);
        this.getChart(data);
    }

    // 获取下拉列表
    getList() {
        getCurrentApplist({ product: 'APP本机校验' }).then((res) => {
            if (res.data.status === 1) {
                this.captchaList = res.data.data;
            }
        });
    }

    // 确认导出
    download() {
        const data = {
            _id: this.currentID,
            start: DateFormat(this.start_time).format('YYYY-MM-DD'),
            end: DateFormat(this.end_time).format('YYYY-MM-DD'),
            is_download: 1,
            product: 'APP本机校验',
        };
        if (this.type === 'fee') {
            this.getChart(data);
        } else if (this.type === 'result') {
            this.getResultChart(data);
        }
    }

    // 明显数据获取
    getChart(data: any) {
        const linOpt = Object.assign({}, lineNegativeOption);
        getCurrentChargeAppReport(data).then((res) => {
            if (res.data.status === 1) {
                if (data.is_download) {
                    this.downloadLink(res.data.data);
                } else {
                    const tp = res.data.data;
                    this.totalFee = tp.request.total;
                    linOpt.series = dataChartFromat(tp.request.data);
                    linOpt.xAxis.data = tp.request.data.time;
                    linOpt.series = [{
                        name: '总计费量', data: tp.request.data.success, type: 'line', symbolSize: 6,
                    }, {
                        name: '总计费金额', data: tp.request.data.charge, type: 'line', symbolSize: 6,
                    }];
                    this.lineOption = Object.assign({}, linOpt);
                }
            } else {
                this.privateThis.$Gtmessage.error(res.data.error_msg);
            }
        });
    }

    // 获取校验结果对比图
    getResultChart(data: any) {
        const barOpt = Object.assign({}, barNegativeOption);
        getCurrentoperatorAppReport(data).then((res: any) => {
            if (res.data.status === 1) {
                if (data.is_download) {
                    this.downloadLink(res.data.data);
                } else {
                    const tm = res.data.data.request;
                    this.failData = tm.total;
                    const bar_opt = this.setBarSeries(this.failData);
                    barOpt.series = [
                        {
                            data: bar_opt.value, type: 'bar', stack: 'one', barMaxWidth: '20', name: '匹配',
                        },
                        {
                            data: bar_opt.t, type: 'bar', stack: 'one', barMaxWidth: '20', name: '不匹配',
                        },
                    ];
                    barOpt.xAxis.boundaryGap = true;
                    barOpt.xAxis.data = bar_opt.name;
                    this.barOption = Object.assign({}, barOpt);
                }
            }
        });
    }

    // eslint-disable-next-line class-methods-use-this
    setBarSeries(data: any) {
        const t: any = data;
        const dataArr: any = [];
        const dataName: any = [];
        const xAxisName: any = [];
        Object.keys(t).forEach((d) => {
            const m = d.slice(0, 2);
            // eslint-disable-next-line no-unused-expressions
            xAxisName.indexOf(m) === -1 && xAxisName.push(m);
            if (d.slice(2) === '匹配量') {
                dataArr.push(t[d]);
            } else {
                dataName.push(t[d]);
            }
        });
        return { name: xAxisName, value: dataArr, t: dataName };
    }

    downloadLink(data: any) {
        const link = document.createElement('a');
        link.href = `${baseUrl}${data}`;
        link.setAttribute('download', 'report.xls');
        document.body.appendChild(link);
        link.click();
        this.privateThis.$Gtmessage.success('下载成功');
        this.isDownload = false;
    }

    created() {
        this.getList();
        this.getData();
    }
}
